import * as React from "react";
import { FormikProps, Formik } from "formik";
import { Form, FormTextArea, Segment } from "@/components/bp/bp-ui";
import { CaseRunClient } from "@app/api2/api";
import SemanticField from "@app/components/SemanticField";
import { RefObject } from "react";
import { BPBoxWithHeader } from "@common/BPBoxWithHeader";

interface ICaseRunNotesProps {
    labId: number;
    caseRunId: number;
    caseId: number;
    notes: string;
    editable?: boolean;
    forPrint?: boolean;
}

class CaseRunNotesFormData {
    public notes: string = '';
}

class CaseRunNotesState {
    isInEditMode: boolean = false;
    form: CaseRunNotesFormData = new CaseRunNotesFormData();
}

export class CaseRunNotes extends React.Component<ICaseRunNotesProps, CaseRunNotesState> {
    private caseRunClient = new CaseRunClient();

    formik: React.Ref<FormikProps<CaseRunNotesFormData>>;

    constructor(props) {
        super(props);

        this.formik = React.createRef();

        var s = new CaseRunNotesState();
        s.form.notes = props.notes;

        this.state = s;
    }

    public render() {

        return <BPBoxWithHeader forPrint={this.props.forPrint} header={window.translation.caseRun.notes}
                buttons={!this.props.forPrint ? [
                    ...(this.props.editable == null || this.props.editable) && this.state.isInEditMode ? [
                        { label: window.translation.common.cancel, action: () => this.cancel() },
                        { label: window.translation.common.save, positive: true, action: () => this.saveNotes() }
                    ] : [],

                    ...(this.props.editable == null || this.props.editable) && !this.state.isInEditMode ? [
                        { label: window.translation.common.edit, action: () => this.toggleEditable() }
                    ] : [],
                ] : []}>
                {this.props.forPrint && <div style={{ minHeight: '10mm' }}>
                    <Segment basic>
                        {this.props.notes}
                    </Segment>
                </div>}

                {!this.props.forPrint && <>
                    <Formik enableReinitialize={false} innerRef={this.formik} initialValues={this.state.form} onSubmit={values => this.submitForm(values)}>
                        {(props) => {
                            return this.renderForm(props)
                        }}
                    </Formik>                    
                </>}
            </BPBoxWithHeader>
    }
    cancel() {
        (this.formik as RefObject<any>).current.resetForm({ notes: this.state.form.notes })
        this.toggleEditable();
    }

    async saveNotes(): Promise<void> {
        await (this.formik as RefObject<any>).current.submitForm();
    }

    async submitForm(values: CaseRunNotesFormData): Promise<void> {
        await this.caseRunClient.updateNotes(this.props.labId, this.props.caseId, this.props.caseRunId, { notes: values.notes });
        this.setState({ form: { notes: values.notes } })
        this.toggleEditable();
    }

    renderForm(props: FormikProps<CaseRunNotesFormData>): React.ReactNode {
        return (<Form>
            <SemanticField component={FormTextArea} readOnly={(this.props.editable == null || this.props.editable) && !this.state.isInEditMode} name="notes" />
        </Form>);
    }

    toggleEditable() {
        this.setState({
            isInEditMode: !this.state.isInEditMode
        });
    }
}
